import { z } from 'my-zod'
import { tableViewsModel } from './table-views-model'

export const tableViewSystemView = tableViewsModel
export type tableViewSystemView = z.infer<typeof tableViewSystemView>
